import { defineStore } from 'pinia'

export const useVariantStore = defineStore('variantStore', () => {
	const versionAutoselect = ref(true)
	const variantSelectionCount = ref(0)
	const automaticVersionSelectTreshold = ref(10)

	const isVersionAutoselectEnabled = computed(() => versionAutoselect.value)
	const getCount = computed(() => variantSelectionCount.value)

	const $reset = () => {
		versionAutoselect.value = true
		variantSelectionCount.value = 0
		automaticVersionSelectTreshold.value = 10
	}

	const incrementVariantSelectionCount = () => {
		variantSelectionCount.value++
	}

	const toggleVersionAutoselect = () => {
		versionAutoselect.value = !versionAutoselect.value
	}

	return {
		versionAutoselect,
		variantSelectionCount,
		automaticVersionSelectTreshold,
		isVersionAutoselectEnabled,
		getCount,
		incrementVariantSelectionCount,
		toggleVersionAutoselect,
		$reset
	}
}, {
	persist: true
})
